import { Box, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { updateChoice, trackSlide } from "areas/product/store/actions"
import { OptionsSelect } from "areas/product/wizard-options/components"

const InternalEngravingOptions = ({ engraving, selectedValue, setChoice }) => {
  return (
    <Box pb={3} pt={1} px={2}>
      <Typography bold color="black" fontSize="14px" letterSpacing="0">
        {engraving.display_label}:
      </Typography>
      <OptionsSelect
        onChange={(e) => {
          setChoice(e)
        }}
        value={selectedValue ? selectedValue.value : ""}
      >
        {engraving.options.map((opt, i) => (
          <option key={`choice_select_${i}`} value={opt.value}>
            {opt.label || opt.value}
          </option>
        ))}
      </OptionsSelect>
    </Box>
  )
}

InternalEngravingOptions.propTypes = {
  engraving: PropTypes.object,
  selectedValue: PropTypes.object,
  setChoice: PropTypes.func,
}

const mapStateToProps = (state, ownProps) => {
  return {
    productType: state.wizard.description.product_type,
    selectedValue: state.choices[ownProps.engraving.pref],
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { productType } = stateProps
  const { dispatch } = dispatchProps
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    setChoice: (e) => {
      const { engraving } = ownProps
      const value = e.target.value
      const option = engraving.options.find((opt) => opt.value === value)
      dispatch(
        updateChoice(engraving.pref, { ...option, is_default: false }, true)
      )
      if (option.track_slide) {
        dispatch(trackSlide(option.track_slide))
      } else if (productType === "WATCH") {
        dispatch(trackSlide("b"))
      }
    },
  }
}

const EngravingOptions = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(InternalEngravingOptions)
export default EngravingOptions
